$(document).ready(function () {
    var privacyRoute = $("#cookie-bar-wrapper").data('privacy');
    $.cookieBar({
        message: jsLangs.message,
        acceptText: jsLangs.acceptText,
        policyText: '',
        policyButton: true,
        policyURL: '',
        bottom: true,
        fixed: true,
        secure: true,
        zindex: '99',
        element: '#cookie-bar-wrapper',
        effect: 'fade'
    });
});